import React from "react";
import { Card, Box, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from "recharts";

const TopTutorsBarChart = ({ data }: { data: { name: string; performance: number }[] }) => (
  <Card sx={{ p: 2, borderRadius: 3 }}>
    <Typography fontWeight={600} mb={2}>Top Performing Tutors</Typography>
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={data}>
        <XAxis dataKey="name" />
        <Tooltip />
        <Bar dataKey="performance" fill="#3B82F6" radius={[8, 8, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </Card>
);


export default TopTutorsBarChart;
